import getUniqueId from 'app/utils/getUniqueId'
import {
    Column,
} from 'app/types/simpletable.types'
import ChipCheckMark from 'app/common/DomainObject/ComponentMapper/ChipCheckMark'
import {
    Location,
} from '../Locations.types'

export type LocationDuplication = Pick<Location, 'locationName' | 'addressLine1' | 'archived'> & {
    companyName: string
}

const columns = ({
    label,
    classes,
}): Column<keyof LocationDuplication>[] => {
    return [
        {
            fieldName: 'locationName',
            label: label('LOCATION'),
            id: getUniqueId(),
        },
        {
            fieldName: 'addressLine1',
            label: label('ADDRESS_LINE_1'),
            className: classes.addressLine1,
            id: getUniqueId(),
        },
        {
            fieldName: 'companyName',
            label: label('COMPANY'),
            id: getUniqueId(),
        },
        {
            fieldName: 'archived',
            label: label('IS_ARCHIVED'),
            id: getUniqueId(),
            className: classes.archived,
            component: ChipCheckMark,
            getProps: ({
                archived,
            }) => {
                return {
                    value: archived,
                }
            },
        },
    ]
}

export default columns
